<!-- Carte principale -->
<div class="rounded-2xl border border-gray-200 dark:border-white/10 p-4 bg-white dark:bg-[#1a1b2b]/90 shadow-sm">
  <!-- Header compact (provider + montant reçu + taux) -->
  <button type="button"
          class="w-full flex items-start justify-between gap-3 text-left"
          (click)="showMainDetails = !showMainDetails">
    <div class="flex items-center gap-2">
      <img *ngIf="swapIconUrl" [src]="swapIconUrl" alt="" class="w-6 h-6 rounded-full" />
      <div class="font-semibold text-gray-900 dark:text-gray-100">{{ dexSource }}</div>
    </div>

    <div class="ml-auto text-right">
      <div class="font-bold text-gray-900 dark:text-white">
        {{ formatAmount(displayedBuyAmount, 6) }} {{ getTokenLabel(buyTokenSymbol) }}
      </div>
      <div class="text-xs text-gray-500 dark:text-gray-400">{{ getBuyAmountFiat() || ' ' }}</div>
    </div>

    <svg class="w-4 h-4 shrink-0 mt-1 transition-transform"
         [ngClass]="{ 'rotate-180': showMainDetails }"
         viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.17l3.71-3.94a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd"/>
    </svg>
  </button>

  <!-- Ligne "taux de conversion" sous le header -->
  <div class="mt-1 text-xs text-gray-500 dark:text-gray-400">
    {{ conversionRateText }}
  </div>

  <!-- Détails façon Uniswap -->
  <div *ngIf="showMainDetails" class="mt-4 space-y-2 text-sm text-gray-700 dark:text-gray-200">
    <div class="flex justify-between">
      <span>{{ 'SELL_TOKEN' | translate }}</span>
      <span class="font-medium">
        {{ formatAmount(displayedSellAmount, 6) }} {{ getTokenLabel(sellTokenSymbol) }}
        <span class="text-xs opacity-70"> {{ getSellAmountFiat() }}</span>
      </span>
    </div>

    <div class="flex justify-between">
      <span>{{ 'NETWORK_FEE' | translate }}</span>
      <span class="font-medium">
        {{ lifiFeeRow.textEth || '—' }}
        <span class="text-xs opacity-70" *ngIf="lifiFeeRow.textFiat"> {{ lifiFeeRow.textFiat }}</span>
      </span>
    </div>

    <div class="flex justify-between">
      <span>{{ 'ROUTING' | translate }}</span>
      <span class="font-medium">Uniswap API</span>
    </div>

    <div class="flex justify-between">
      <span>{{ 'PRICE_IMPACT' | translate }}</span>
      <span class="font-medium">—</span>
    </div>

    <div class="flex justify-between">
      <span>{{ 'SLIPPAGE_MAX' | translate }}</span>
      <span class="font-medium">{{ 'AUTOMATIC' | translate }} (—)</span>
    </div>
  </div>

  <!-- Barre d’actions -->
  <div class="mt-4 flex items-stretch gap-3">
    <button type="button"
            class="flex-1 rounded-xl px-3 py-2 border hover:shadow-sm transition
                   bg-white text-blue-700 border-blue-200 text-sm
                   dark:bg-transparent dark:text-blue-300 dark:border-blue-500/30"
            (click)="executeRequest.emit()"
            [disabled]="swapDisabled">
      <div class="flex items-center justify-center gap-2 font-semibold">
        <img src="assets/icons/validate-checkmark.png" class="h-4 w-auto" alt="Validate" />
        <span>{{ 'VALIDATE' | translate }}</span>
      </div>
    </button>

    <button type="button"
            class="rounded-xl px-3 py-2 border text-sm hover:shadow-sm
                   bg-white text-gray-700 border-gray-200
                   dark:bg-transparent dark:text-gray-300 dark:border-white/10"
            (click)="onClose()">
      {{ 'CLOSE' | translate }}
    </button>
  </div>

  <!-- Statuts transaction -->
  <div class="text-xs text-center mt-3 space-y-1">
    <div *ngIf="swapStatus === 'approve'" class="text-blue-600 dark:text-blue-300">🔐 {{ 'APPROVE_PENDING' | translate }}</div>
    <div *ngIf="swapStatus === 'pending'" class="text-blue-600 dark:text-blue-300">⏳ {{ 'SWAP_PENDING' | translate }}</div>
    <div *ngIf="swapStatus === 'success'" class="text-green-600 dark:text-green-400">
      ✅ {{ 'SWAP_SUCCESS' | translate }}
      <a *ngIf="swapHash" [href]="'https://etherscan.io/tx/' + swapHash" target="_blank" class="underline ml-1">
        {{ swapHash | slice:0:10 }}…
      </a>
    </div>
    <div *ngIf="swapStatus === 'cancelled' || (swapStatus === 'error' && isUserCancelled(swapError))"
         class="text-gray-600 dark:text-gray-300">
      {{ 'SWAP_CANCELLED' | translate }}
    </div>
    <div *ngIf="swapStatus === 'error' && !isUserCancelled(swapError)"
         class="text-gray-600 dark:text-gray-300">
      ℹ️ {{ 'SWAP_INFO' | translate }} : {{ swapError }}
    </div>
  </div>

  <!-- Ouvrir/fermer les alternatives -->
  <div class="mt-3 text-center" *ngIf="(otherRoutes?.length || 0) > 0 && !showAlternatives">
    <button type="button" class="text-sm text-blue-600 underline" (click)="showAlternatives = true">
      {{ 'SEE_OTHER_RESULTS' | translate }}
    </button>
  </div>

  <!-- Alternatives -->
  <div *ngIf="showAlternatives" class="mt-4 rounded-2xl border bg-white/90 dark:bg-[#0f1220]/80 border-gray-200 dark:border-white/10">
    <div *ngFor="let r of otherRoutes; let i = index" class="border-b last:border-0 border-gray-100/70 dark:border-white/10">
      <!-- Ligne compacte -->
      <button type="button"
              class="w-full px-4 py-3 flex items-center justify-between gap-3 text-left"
              (click)="toggleAlt(r)">
        <div class="flex items-center gap-2 min-w-0">
          <img *ngIf="getRouteLogo(r)" [src]="getRouteLogo(r)!" class="w-5 h-5 rounded-full" alt="" />
          <span class="font-medium truncate">{{ getRouteProvider(r) }}</span>
        </div>

        <div class="text-right">
          <div class="font-medium">{{ getRouteEstimatedBuy(r) }}</div>
          <div class="text-xs text-gray-500 dark:text-gray-400">{{ getRouteEstimatedBuyFiat(r) }}</div>
        </div>

        <svg class="w-4 h-4 shrink-0 transition-transform"
             [ngClass]="{ 'rotate-180': expandedAlt[keyOf(r)] }"
             viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.17l3.71-3.94a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd"/></svg>
      </button>

      <!-- Détails par alternative -->
      <div *ngIf="expandedAlt[keyOf(r)]" class="px-4 pb-4 text-sm text-gray-700 dark:text-gray-200">
        <div class="flex justify-between">
          <span>{{ 'NETWORK_FEE' | translate }}</span>
          <span class="font-medium">
            {{ getRouteLifiFee(r).textEth || '—' }}
            <span class="text-xs opacity-70" *ngIf="getRouteLifiFee(r).textFiat"> {{ getRouteLifiFee(r).textFiat }}</span>
          </span>
        </div>

        <div class="mt-3 text-right">
          <button type="button"
                  class="inline-flex items-center gap-2 px-3 py-1.5 rounded-xl border text-sm
                         bg-green-600 text-white border-green-600 hover:opacity-90
                         disabled:bg-transparent disabled:text-gray-400 disabled:border-gray-300 disabled:cursor-not-allowed"
                  (click)="chooseAlternative(r)"
                  [disabled]="isAlternativeDisabled(r)">
            ✓ {{ 'VALIDATE' | translate }}
          </button>
        </div>
      </div>
    </div>

    <div class="py-3 text-center">
      <button type="button" class="text-sm text-blue-600 underline" (click)="showAlternatives = false">
        {{ 'CLOSE_TABLE' | translate }}
      </button>
    </div>
  </div>
</div>

<!-- Micro-polish numbers -->
<style>
  :host { display:block }
  .tabnums { font-variant-numeric: tabular-nums lining-nums; letter-spacing:.01em }
</style>
